import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory,
    DimensionsById,
    addSet
} from "../../core";
import { IDashboardViewModel } from "./viewModel";

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export interface ISourceBuilder  {
    uniques: Set<string>;
    values: ISourceData;
}

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
const createData = createCoreData;

/**
 * Create a new source data object
 */
export function createBuilder(): ISourceBuilder {
    return {
        uniques: new Set(),
        values: createData(),
    };
}

/**
 * Overcomplicated way to ensure consistent coloring for references
 * of unknown size.
 */
export function toColors(groupReferences: DimensionsById, groupLabels: string[], colors: string[], unknownColor: string): string[] {
    const keys = Object.keys(groupReferences).filter(p => Object.prototype.hasOwnProperty.call(groupReferences, p));

    const mappedColors = [];
    for (let i = 0; i < groupLabels.length; i++) {
        const label = groupLabels[i];
        //Force Unk to be green
        if (label === "Unk") {
            mappedColors.push(unknownColor);
            break;
        }

        //Otherwise use the index - they shouldn't overlap
        for (const key of keys) {
            const g = groupReferences[key];
            if (label === g.name) {
                mappedColors.push(colors[g.id - 1]);
                break;
            }
        }
    }

    return mappedColors;
}

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
const add = addDataFactory((vm: IDashboardViewModel) => vm.hhsResidenceGroup?.name);

/**
 * Returns the number added to the hierarchy on add, 0 otherwise. 
 * @param vm 
 * @param into 
 * @param filter 
 */
export function addData(vm: IDashboardViewModel, into: ISourceBuilder): number {
    //Only count once per unique (hhsResidenceGroup + diagnosisId ) since we're counting mdt participation.
    if (addSet(vm.hhsResidenceGroup?.id + "_" + vm.diagnosisId, into.uniques)) {
        add(vm, into.values);
        return 1;
    }

    return 0;
}

/** 
 * Complete adding data and clear any temporary resources 
 */
export function finish(builder: ISourceBuilder): ISourceData {
    try {
        return builder.values;
    } finally {
        builder.uniques.clear();
        builder.uniques = null;
        builder.values = null;
        builder = null;
    }
}